import React, { Fragment } from 'react';
import AdminBreadcrumb from '../../components/Administration/General/Admin-breadcrumb';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

const IcedApplications = () => {
  const history = useHistory();
  const RoleBasedView = useSelector((state) => state.adminAccountReducer.RoleBasedView);

  const Apps = [
    // {
    //   id: 1,
    //   Name: 'ICED',
    //   path: 'https://gsd-insight.dxc.com/ICED/',
    //   enable: true,
    //   visible: RoleBasedView?.[0]?.['AQuAA Agent']?.[0]?.Read, 
    // },
    {
      id: 2,
      Name: 'ICED',
      path: '/iced',
      enable: true,
      visible: RoleBasedView?.[0]?.['AQuAA Agent']?.[0]?.Read,
    },
    {
      id: 3,
      Name: 'ICED Reports',
      path: '/icedreports',
      enable: true,
      visible: 1,
    },
  ];

  return (
    <Fragment>
      <AdminBreadcrumb
        value1={() => history.push('/applications')}
        label1="Applications"
        isActive2={false}
        label2="ICED"
      />

      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {Apps.map((app, index) =>
          app.enable && app.visible === 1 ? (
            app.id === 1 ? (
              <a
                href={app.path}
                target="_blank"
                rel="noopener noreferrer"
                className="App_cards"
                key={app.id}
                style={{ textDecoration: 'none' }}
              >
                {app.img ? (
                  <img src={app.img} alt="" height="200px" width="200px" />
                ) : (
                  <div
                    style={{
                      height: '200px',
                      width: '200px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontSize: '24px',
                      fontWeight: 'bold',
                      border: '1px solid #ccc',
                      color: '#004aac',
                      textAlign: 'center',
                    }}
                  >
                    {app.Name}
                  </div>
                )}
              </a>
            ) : (
              // Internal links (React routes)
              <div
                className="App_cards"
                key={app.id}
                onClick={() => history.push(app.path)}
                style={{ cursor: 'pointer' }}
              >
                {app.img ? (
                  <img src={app.img} alt="" height="200px" width="200px" />
                ) : (
                  <div
                    style={{
                      height: '200px',
                      width: '200px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      fontSize: '24px',
                      fontWeight: 'bold',
                      border: '1px solid #ccc',
                      color: '#004aac',
                      textAlign: 'center',
                    }}
                  >
                    {app.Name}
                  </div>
                )}
              </div>
            )
          ) : null
        )}
      </div>
    </Fragment>
  );
};

export default IcedApplications;
